import styled from "styled-components";

interface IStyledAttachment {
  styleWrapper?:{
    fullWidth?: boolean;
    isBold?: boolean;
  }
}


export const StyledAttachment = styled.div<IStyledAttachment>(({ theme, styleWrapper }) => `
    overflow: hidden;
    padding: ${theme.uptimeSpace[0]};
    margin-bottom: ${theme.uptimeSpace[2]}px;
    max-width: ${styleWrapper?.fullWidth ? "none" : "240px"};
    .attachments {
      list-style-type: none;
      margin: ${theme.uptimeSpace[0]};
      padding: ${theme.uptimeSpace[0]};
      li {
        display: flex;
        align-items: center;
        width: 100%;
        margin-top: ${theme.uptimeSpace[2]}px;
        &:first-child {
          margin-top: ${theme.uptimeSpace[0]};
        }
      }
    }
    .remove-icon {
      margin-right: ${theme.uptimeSpace[6]}px;
      width: 10px;
      cursor: pointer;
    }
    svg {
      color: ${theme.uptimeColors.grayScales.black};
      width: 20px;
    }
    button {
      border: none;
      background: none;
      padding: ${theme.uptimeSpace[0]};
      margin-left: ${theme.uptimeSpace[6]}px;
      cursor: pointer;
      img {
        width: 22px;
      }
    }
    .file-name {
      margin: ${theme.uptimeSpace[2]}px;
      display: flex;
      flex-direction: row;
      flex-wrap: nowrap;
      justify-content: flex-start;
      color: black;
      font-style: normal;
      font-weight: normal;
      font-size: ${theme.uptimeFontSizes.desktop.fz2}px;
      line-height: ${theme.uptimeLineHeights.desktop.lh6}px;
      text-decoration-line: none;
      font-weight: ${styleWrapper?.isBold ? "bold" : "normal"};
      max-width: ${styleWrapper?.fullWidth ? "none" : "100px"};
      word-break: break-all;
      &:hover {
        cursor: pointer;
      }
      .start {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        flex-shrink: 1;
      }
      .end {
        white-space: nowrap;
        flex-basis: content;
        flex-grow: 0;
        flex-shrink: 0;
      }
    }

    .MuiTooltip-popper {
      z-index: 99999999999999 !important;
    }
    .loading-attachment{
      padding-left: ${theme.uptimeSpace[4]}px;
    }
    .icon-delete {
      width: 34px;
    }
  `
);

export const StyledCircularProgress = styled.div(({ theme }) =>`
  .MuiCircularProgress-svg{
    color: ${theme.uptimeColors.mainTheme.primary} !important;
    width: 100% !important;
    height: 100% !important;
  }
`);
export const CircularSize = {
  width: "24px",
  height: "24px",
}